import { getId, getToken, removeId, removeToken, setId, setToken } from '@/utils/auth';
import { getInfo, login, logout } from '@/api/home/login';
import { getSelectData } from '@/api/commApi/xdApi';
import Cookies from 'js-cookie';
import { resetRouter } from '@/router';
const Base64 = require("js-base64").Base64;

function setUserInfo(loginForm) {
    const obj = {
        username: loginForm.username,
        password: Base64.encode(loginForm.password)
    };
    Cookies.set('dsu-info', Base64.encode(JSON.stringify(obj)), { expires: 7 });
}
function getUserInfo() {
    const dsuInfo = Cookies.get('dsu-info');
    if(dsuInfo) {
        return JSON.parse(Base64.decode(dsuInfo));
    }
    return null;
}
function removeUserInfo() {
    Cookies.remove('dsu-info');
}

const user = {
    state: {
        token: getToken(),
        name: null,
        messageNoReadNum: 0,
        haveOutEmp: false, // 是否有下级工程人员
        hasTx: false, // 是否有腾讯账户
        levels: [],
        avatar: null,
        id: getId(),
        eName: localStorage.getItem('eName'),
        tenantId: null,
        city: 205,
        province: 18,
        latLng: {},
        phone: ""
    },

    mutations: {
        SET_TOKEN: (state, token) => {
            state.token = token;
        },
        SET_NAME: (state, name) => {
            state.name = name;
        },
        SET_LEVELS: (state, levels) => {
            state.levels = levels;
        },
        SET_HAVAOUTEMP: (state, haveOutEmp) => {
            state.haveOutEmp = haveOutEmp;
        },
        SET_HAS_TX: (state, hasTx) => {
            state.hasTx = hasTx;
        },
        SET_AVATAR: (state, avatar) => {
            state.avatar = avatar;
        },
        SET_ID: (state, id) => {
            state.id = id;
        },
        SET_ENAME: (state, eName) => {
            state.eName = eName;
        },
        SET_CITYMAP: (state, latLng) => {
            state.latLng = latLng;
        },
        SET_PHONE: (state, phone) => {
            state.phone = phone;
        },
        SET_TENANT_Id: (state, tenantId) => {
            state.tenantId = tenantId;
        },
        SET_CITY: (state, city) => {
            state.city = city;
        },
        SET_PROVINCE: (state, province) => {
            state.province = province;
        },
        SET_MESSAGE_NO_READ_NUM: (state, messageNoReadNum) => {
            state.messageNoReadNum = messageNoReadNum;
        }
    },

    actions: {
        GetUserInfoInCookie({ commit }) {
            return new Promise((resolve, reject) => {
                const dsuInfo = getUserInfo();
                if(!dsuInfo) {
                    reject();
                    return;
                }
                if(dsuInfo.username && dsuInfo.password) {
                    const obj = {
                        username: dsuInfo.username,
                        password: Base64.decode(dsuInfo.password)
                    };
                    resolve(obj);
                }else {
                    reject();
                }
            });
        },
        UpdatePwd({ commit }, token) {
            return new Promise((resolve, reject) => {
                setToken(token);
                commit('SET_TOKEN', token);
                resolve();
            });
        },
        // 登录
        Login({ commit }, userInfo) {
            const username = userInfo.username.trim();
            const storePwd = userInfo.isChecked;
            return new Promise((resolve, reject) => {
                login({
                    account: username,
                    password: userInfo.password
                }).then(response => {
                    const data = response.data;
                    setToken(data.tokenId);
                    setId(data.userId);
                    commit('SET_TOKEN', data.tokenId);
                    commit('SET_ID', data.userId);
                    commit('SET_ENAME', data.eName);
                    commit('SET_AVATAR', data.header);
                    localStorage.setItem('id', data.userId);
                    localStorage.setItem('eName', data.eName);
                    if(typeof storePwd === 'boolean') {
                        if(storePwd) {
                            setUserInfo(userInfo);
                        }else {
                            removeUserInfo();
                        }
                    }
                    resolve();
                }).catch(error => {
                    reject(error);
                });
            });
        },

        // 获取用户信息
        GetInfo({ commit, state }) {
            return new Promise((resolve, reject) => {
                getInfo({
                    token: getToken(),
                    empId: getId()
                }).then(response => {
                    const data = response.data;
                    commit('SET_NAME', data.name);
                    commit('SET_HAVAOUTEMP', data.haveOutEmp);
                    commit('SET_LEVELS', data.levels);
                    commit('SET_AVATAR', data.header);
                    commit('SET_CITY', data.tcity || 205);
                    commit('SET_PROVINCE', data.tprovince || 18);
                    commit('SET_CITYMAP', {
                        lat: data.tcityLat || 30.599488,
                        lng: data.tcityLng || 114.31117,
                        city: data.tcity || 205,
                        province: data.tprovince || 18,
                        cityName: data.tcityName || "武汉市",
                        provinceName: data.tprovinceName || "湖北省"
                    });
                    commit('SET_PHONE', data.phone);
                    commit('SET_TENANT_Id', data.tenantId);
                    commit('SET_MESSAGE_NO_READ_NUM', data.messageNoReadNum);
                    // 获取是否有腾讯账户
                    getSelectData('txTenantId', data.tenantId).then(res => {
                        if(res.success) {
                            commit('SET_HAS_TX', Array.isArray(res.data) && res.data.length > 0);
                        }
                    });
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },

        // 登出
        LogOut({ commit, state }) {
            return new Promise((resolve, reject) => {
                logout(state.token).then(() => {
                    commit('SET_TOKEN', '');
                    commit('SET_NAME', '');
                    commit('SET_LEVELS', '');
                    commit('SET_HAVAOUTEMP', '');
                    commit('SET_MODULES', []);
                    commit('SET_AVATAR', '');
                    localStorage.clear();
                    removeUserInfo();
                    removeToken();
                    removeId();
                    resetRouter();
                    resolve();
                }).catch(error => {
                    reject(error);
                });
            });
        },


        // 前端 登出
        FedLogOut({ commit }) {
            return new Promise(resolve => {
                commit('SET_TOKEN', '');
                commit('SET_AVATAR', '');
                commit('SET_MODULES', []);
                localStorage.clear();
                removeUserInfo();
                removeToken();
                removeId();
                resetRouter();
                resolve();
            });
        }
    }
};

export default user;
